import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { paths } from '@/shared/config/paths';
import { withSuspense } from '../utils';

// 운영 관리
const NewsCreate = lazy(() => import('@pages/operation/news/NewsCreate'));
const NewsEdit = lazy(() => import('@pages/operation/news/NewsEdit'));
const InstagramCreate = lazy(() => import('@pages/operation/instagram/InstagramCreate'));
const InstagramEdit = lazy(() => import('@pages/operation/instagram/InstagramEdit'));
const YoutubeCreate = lazy(() => import('@pages/operation/youtube/YoutubeCreate'));
const YoutubeEdit = lazy(() => import('@pages/operation/youtube/YoutubeEdit'));
const PrivacyPolicyCreate = lazy(() => import('@pages/operation/privacyPolicy/PrivacyPolicyCreate'));
const TermsOfServiceCreate = lazy(() => import('@pages/operation/termsOfService/TermsOfServiceCreate'));
const QrCreate = lazy(() => import('@/pages/event/qr/QrCreate'));
const PartnerCreate = lazy(() => import('@/pages/partner/join/PartnerCreate'));
// 관리자
const AdminCreate = lazy(() => import('@pages/system/admin/AdminCreate'));
const AdminEdit = lazy(() => import('@pages/system/admin/AdminEdit'));

// 전체 화면 페이지
export const fullScreenRoutes: RouteObject[] = [
	// 콘텐츠 관리
	// 뉴스
	{
		path: paths.operation.news.new.path,
		element: withSuspense(NewsCreate),
		handle: {
			title: '뉴스 추가하기',
			subTitle: '고객향 새로운 뉴스 추가하기',
		},
	},
	{
		path: paths.operation.news.edit.path,
		element: withSuspense(NewsEdit),
		handle: {
			title: '뉴스 수정하기',
			subTitle: '고객향 뉴스 수정하기',
		},
	},
	// 인스타
	{
		path: paths.operation.instagram.new.path,
		element: withSuspense(InstagramCreate),
		handle: {
			title: '인스타그램 링크 추가',
			subTitle: '고객향 인스타그램 추가하기',
		},
	},
	{
		path: paths.operation.instagram.edit.path,
		element: withSuspense(InstagramEdit),
		handle: {
			title: '인스타그램 링크 수정',
			subTitle: '고객향 인스타그램 수정하기',
		},
	},
	// 유튜브
	{
		path: paths.operation.youtube.new.path,
		element: withSuspense(YoutubeCreate),
		handle: {
			title: '유튜브 링크 추가',
			subTitle: '고객향 유튜브 링크 추가하기',
		},
	},
	// 이벤트
	{
		path: paths.event.qr.new.path,
		element: withSuspense(QrCreate),
		handle: {
			isGoBack: true,
			title: '새로운 QR 추가하기',
			subTitle: '새로운 당첨 이벤트 QR 추가하기',
		},
	},
	// 파트너
	{
		path: paths.partner.join.new.path,
		element: withSuspense(PartnerCreate),
		handle: {
			isGoBack: true,
			title: '파트너사 수동 추가',
			subTitle: '새로운 파트너사 수동 추가하기',
		},
	},
	{
		path: paths.partner.join.edit.path,
		element: withSuspense(PartnerCreate),
		handle: {
			isGoBack: true,
			title: '파트너사 정보 수정',
			subTitle: '파트너사 가입 상세 정보 수정하기',
		},
	},
	{
		path: paths.operation.youtube.edit.path,
		element: withSuspense(YoutubeEdit),
		handle: {
			title: '유튜브 링크 수정',
			subTitle: '고객향 유튜브 링크 수정하기',
		},
	},
	// 개인정보 처리방침
	{
		path: paths.operation.privacyPolicy.new.path,
		element: withSuspense(PrivacyPolicyCreate),
		handle: {
			title: '개인정보 처리방침 등록',
			subTitle: '개인정보 처리방침 등록하기',
		},
	},
	// 이용약관
	{
		path: paths.operation.termsOfService.new.path,
		element: withSuspense(TermsOfServiceCreate),
		handle: {
			title: '이용약관 등록',
			subTitle: '이용약관 등록하기',
		},
	},
	// 관리자
	{
		path: paths.system.admin.new.path,
		element: withSuspense(AdminCreate),
		handle: {
			title: '관리자 계정 생성',
			subTitle: '관리자 새로운 계정 생성하기',
		},
	},
	{
		path: paths.system.admin.edit.path,
		element: withSuspense(AdminEdit),
		handle: {
			title: '관리자 계정 수정',
			subTitle: '관리자 계정 수정하기',
		},
	},
];
